class SmoothScroll {
	constructor() {
		smoother = ScrollSmoother.create({
			smooth: 0.8
		});
	}
}
